// extracted by mini-css-extract-plugin
module.exports = {"authorByline":"AuthorByline_authorByline__xD9lx","moreCheckbox":"AuthorByline_moreCheckbox__h3DqP","authorBylineFlexContainer":"AuthorByline_authorBylineFlexContainer__8TtaN"};